import React from "react";
import "./SkeletonVideoFeed.css";

const SkeletonVideoFeedElement = ({ type }) => {
  const classes = `skeletonV ${type}`;

  return <div className={classes}></div>;
};

export default SkeletonVideoFeedElement;
